import { FC } from 'react';
import Link from 'next/link';
import styles from './BookTabs.module.scss';

interface IBookTabs {
  bookAlias: string;
  bookPageName?: string;

  bookPage?: boolean;
  reviewsPage?: boolean;
  quotesPage?: boolean;
  readPage?: boolean;

  readTxt?: boolean;
  reviews?: boolean;
  quotes?: boolean;

  reviewsCount?: number;
  quotesCount?: number;
}

const BookTabs: FC<IBookTabs> = ({ bookPage, reviewsPage, quotesPage, readPage, reviews, quotes, readTxt, quotesCount, reviewsCount, bookAlias, bookPageName }) => {
  const getBookPageName = () => (!!bookPageName ? bookPageName : 'О книге');

  return (
    <div className={styles.tabMenu}>
      <ul>
        <li>
          {!!bookPage ? (
            <span className={`${styles.tabMenu__item} ${styles.tabMenu__item_active}`}>{getBookPageName()}</span>
          ) : (
            <Link prefetch={false} className={styles.tabMenu__item} href={bookAlias}>
              {getBookPageName()}
            </Link>
          )}
        </li>

        {reviews && Number(reviewsCount) > 0 && (
          <li>
            {!!reviewsPage ? (
              <span className={`${styles.tabMenu__item} ${styles.tabMenu__item_active}`}>
                Отзывы <span className={styles.count}> {reviewsCount}</span>
              </span>
            ) : (
              <Link prefetch={false} className={styles.tabMenu__item} href={`${bookAlias}reviews/`}>
                Отзывы <span className={styles.count}> {reviewsCount}</span>
              </Link>
            )}
          </li>
        )}

        {quotes && Number(quotesCount) > 0 && (
          <li>
            {!!quotesPage ? (
              <span className={`${styles.tabMenu__item} ${styles.tabMenu__item_active}`}>
                Цитаты <span className={styles.count}> {quotesCount}</span>
              </span>
            ) : (
              <Link prefetch={false} className={styles.tabMenu__item} href={`${bookAlias}quotes/`}>
                Цитаты <span className={styles.count}> {quotesCount}</span>
              </Link>
            )}
          </li>
        )}

        {!!readTxt && (
          <li>
            {!!readPage ? (
              <span className={`${styles.tabMenu__item} ${styles.tabMenu__item_active}`}>Читать</span>
            ) : (
              <Link prefetch={false} className={styles.tabMenu__item} href={`${bookAlias}read/`}>
                Читать
              </Link>
            )}
          </li>
        )}
      </ul>
    </div>
  );
};

export default BookTabs;
